const ZZ = ZZ || {};

(function() {
    "use strict";

    ZZ.initialized = [];

    // CustomEvents polyfill
    (function() {
        if (typeof window.CustomEvent === "function") return false;

        function CustomEvent(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            let evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(
                event,
                params.bubbles,
                params.cancelable,
                params.detail
            );
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    })();

    /**
     * Find a single initialized module by it's HTMLElement and Module constructor
     * @param {HTMLElement} element
     * @param {Function} constructor
     * @returns {{element: HTMLElement, constructor: Function, instance: {}} | Boolean}
     */
    ZZ.initializedByElement = function(element, constructor) {
        var result = ZZ.initialized.filter(function(init) {
            return (
                getHTMLElement(init.element) === getHTMLElement(element) &&
                init.constructor === constructor
            );
        });
        return result[0] || false;
    };

    /**
     * Find all initialized modules for a single HTMLElement
     * @param {HTMLElement} element
     * @returns {Array<{element: HTMLElement, constructor: Function, instance: {}}>}
     */
    ZZ.initializedByElements = function(element) {
        return ZZ.initialized.filter(function(init) {
            return getHTMLElement(init.element) === getHTMLElement(element);
        });
    };

    /**
     * Bootstrap only specific VanillaJS compatible modules ['GtmTouchpoint', 'GtmTouchpointInput']
     * with a `data-interaction` attribute
     *
     * @param {String} [root] - Selector
     */
    ZZ.init = function(root) {
        var isElement = root instanceof HTMLElement;

        !isElement &&
            (this.root =
                typeof root !== "undefined"
                    ? document.querySelector(root)
                    : document.querySelector("body"));

        isElement && (this.root = root);

        var interactionElements = this.root.querySelectorAll(
            "[data-interaction]:not([data-initialized])"
        );
        this.permittedModules = [
            "GtmTouchpoint",
            "GtmTouchpointInput",
            "GtmTouchpointMounted"
        ];

        var objectToCall, objectsToCall, i;

        // add root-node to collection if needed
        if (
            typeof this.root.getAttribute("data-interaction") !== "undefined" &&
            typeof this.root.getAttribute("data-initialized") === "undefined"
        ) {
            if (interactionElements.length > 0) {
                interactionElements.add(this.root);
            } else {
                interactionElements = this.root;
            }
        }

        if (interactionElements.length > 0) {
            Array.prototype.forEach.call(interactionElements, function(
                interactionElement
            ) {
                objectToCall = interactionElement.getAttribute(
                    "data-interaction"
                );

                objectsToCall = objectToCall.trim().split(" ");
                for (i = 0; i < objectsToCall.length; i++) {
                    objectToCall = objectsToCall[i];
                    var existsOnZZ = ZZ.hasOwnProperty(objectToCall);
                    try {
                        if (existsOnZZ) {
                            // jQuery
                            ZZ.initialized.push({
                                element: interactionElement,
                                constructor: ZZ[objectToCall],
                                instance: new ZZ[objectToCall](
                                    $(interactionElement)
                                ) // Needed for jQuery modules
                            });
                        } else {
                            // es6
                            var options = JSON.parse(
                                JSON.stringify(interactionElement.dataset)
                            );
                            ZZ.initialized.push({
                                element: interactionElement,
                                constructor: window[objectToCall],
                                instance: new window[objectToCall](
                                    interactionElement,
                                    options
                                )
                            });
                        }
                    } catch (error) {
                        console.error(
                            "objectToCall " + objectToCall + " -> " + error
                        );
                    }
                    interactionElement.setAttribute("data-initialized", "true");
                }
            });
        }

        // Signal all modules have finished loading
        this.root.setAttribute("data-finished-loading", "true");

        // Create and initialize custom event
        var event = document.createEvent("HTMLEvents");
        event.initEvent("data-finished-loading", true, false);
        this.root.dispatchEvent(event);
    };

    /**
     * Turns a jQuery element or plain HTMLElement into HTMLElement
     * @param {jQuery<HTMLElement> | HTMLElement} elem
     * @returns {HTMLElement}
     * @private
     */
    var getHTMLElement = function(elem) {
        return elem instanceof $ ? elem[0] : elem;
    };
})();

$(function () {
    ZZ.init('body', false);
});
